import { track } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'
import { WhatBringsYouVariantPALM } from './components/WhatBringsYouVariantPALM'

const QUIZ_MODULE_ROW_VIEWED = 'Quiz Module Row Viewed'

export const DroppableQuizVariant1 = () => (
  <TrackingContainer onFirstVisible={() => track(QUIZ_MODULE_ROW_VIEWED)}>
    <div className='container'>
      <WhatBringsYouVariantPALM />
    </div>
  </TrackingContainer>
)
